// extracted by mini-css-extract-plugin
export default {"primaryButton":"primary_primaryButton__MD5gs"};